module.exports = __webpack_public_path__ + "img/forbes.02a428d2.svg";